module.exports = __webpack_public_path__ + "img/作业试卷.c21c8485.svg";